import { render, staticRenderFns } from "./ProposalCard.vue?vue&type=template&id=6a4cf2d6"
import script from "./ProposalCard.vue?vue&type=script&lang=js"
export * from "./ProposalCard.vue?vue&type=script&lang=js"
import style0 from "./ProposalCard.vue?vue&type=style&index=0&id=6a4cf2d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports